<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-- Nome do Produto -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Produto</span>
          <vs-input class="w-full" name="Nome Produto" id="Nome Produto" v-model="formCadastro.nomeProduto"
            v-validate="{ required: true }" :state="utilsList.validateState(veeFields, veeErrors, 'Nome Produto')
              " :danger="!utilsList.validateState(veeFields, veeErrors, 'Nome Produto')
                " val-icon-danger="clear" danger-text="Preencha este Campo" />
        </div>
      </div>

      <!-- Cor -->
      <div class="vx-row mb-6">
        <div class="vx-col mb-6">
          <label for="corHexa">Cor</label>
          <div class="input-group-color">
            <input type="color" size="large" class="w-full color-picker" name="corHexa" id="corHexa"
              @change="changeThemeColor" v-model="formCadastro.corHexaDefault" v-validate="{ required: false }"
              :state="validateState('corHexa')" :danger="validateClass('corHexa')" val-icon-danger="clear"
              danger-text="Preencha este Campo" icon-no-border />
            <vs-input class="w-full" name="corHexa" id="corHexa" @keyup.native="changeThemeColor"
              v-model="formCadastro.corHexaDefault" v-validate="{ required: false }" :state="validateState('corHexa')"
              :danger="validateClass('corHexa')" val-icon-danger="clear" danger-text="Preencha este Campo"
              icon-no-border />
          </div>
        </div>
      </div>

      <!-- Imagem -->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Imagem (160 x 160)</div>
          <center v-if="formCadastro.imagem">
            <img :src="formCadastro.imagem" width="100%" style="max-width: 190px" />
          </center>
          <input id="fileUpload" type="file" hidden @change="selecionaImagem" />
          <vs-button color="warning" type="border" class="mr-3 text-center" @click.stop.prevent="chooseFiles">
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <br />
            <vs-chip v-if="imagem" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ imagem }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <!-- Valor Intangível -->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Valor Intangível</span>
          <vs-switch color="success" v-model="formCadastro.valorIntangivel" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <!-- Coin -->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Coin</span>
          <vs-switch color="success" v-model="formCadastro.coin" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <!-- Sincronizar Integração -->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Sincronizar Integração</span>
          <vs-switch color="success" v-model="formCadastro.syncJobUpdate" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <!-- Sincronizar Voucher -->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Voucher</span>
          <vs-switch color="success" v-model="formCadastro.isVoucher" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <!-- Gerenciar Vouchers -->
      <div class="vx-row" v-if="formCadastro.isVoucher">
        <div class="vx-col mb-6">
          <vs-button color="primary" type="border" class="mr-3" @click.stop.prevent="abrirModalVoucher">
            Gerenciar Vouchers
          </vs-button>
        </div>
      </div>

      <!-- Popup (Modal) para Adicionar Vouchers -->
      <vs-popup class="holamundo" title="Gerenciar Vouchers" @cancel="clearFormVoucher"
        :active.sync="activePromptVoucher">
        <div>
          <div class="my-2">
            <label>Código do Voucher</label>
            <vs-input class="w-full" name="voucherCodigo" id="voucherCodigo" v-model="formVoucher.codigo"
              val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>

          <vs-button color="success" class="w-full mt-2" @click="salvarVoucher">
            Adicionar
          </vs-button>

          <div class="mt-4">
            <vs-list-item v-for="(item, index) in formCadastro.vouchers" :key="index" :title="item.voucher"
              :subtitle="'Usado: ' + (item.requested === 1 ? 'Sim' : 'Não')">
              <template #avatar>
                <!-- Se não foi usado, mostra botão excluir -->
                <vs-button v-if="item.requested === 0" @click.stop.prevent="deletaVoucher(index)" class="mr-2"
                  color="danger" type="border" icon="clear" />
                <!-- Se já foi usado, desabilita -->
                <vs-chip v-else color="success">
                  Usado
                </vs-chip>
              </template>
            </vs-list-item>
          </div>
        </div>
      </vs-popup>

      <!-- Preço Anunciado -->
      <div class="vx-row mb-6" v-if="!formCadastro.valorIntangivel">
        <div class="vx-col w-full">
          <span>Preço Anunciado</span>
          <money class="w-full vs-inputx vs-input--input large" name="Preço Anunciado" id="Preço Anunciado"
            v-model="formCadastro.valorEstimado" v-validate="{ required: true }" :state="utilsList.validateState(veeFields, veeErrors, 'Preço Anunciado')
              " :danger="!utilsList.validateState(veeFields, veeErrors, 'Preço Anunciado')
                " v-bind="money2"></money>
        </div>
      </div>

      <!-- Valor Custo de Mercadoria -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor Custo de Mercadoria</span>
          <money class="w-full vs-inputx vs-input--input large" name="Valor Custo de Mercadoria"
            id="Valor Custo de Mercadoria" v-model="formCadastro.valorCompra"
            v-validate="{ required: !formCadastro.valorIntangivel }" :state="utilsList.validateState(
              veeFields,
              veeErrors,
              'Valor Custo de Mercadoria'
            )
              " :danger="!utilsList.validateState(
                veeFields,
                veeErrors,
                'Valor Custo de Mercadoria'
              )
                " v-bind="money2"></money>
        </div>
      </div>

      <!-- Descrição -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Descrição</span>
          <quill-editor :content="formCadastro.descricao" :options="editorOption"
            @change="onEditorChange($event)"></quill-editor>
        </div>
      </div>

      <!-- Dimensões -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Altura (em cm)</span>
          <money class="w-full vs-inputx vs-input--input large" name="Altura" id="Altura" v-model="formCadastro.altura"
            v-validate="{ required: !formCadastro.valorIntangivel }"
            :state="utilsList.validateState(veeFields, veeErrors, 'Altura')"
            :danger="!utilsList.validateState(veeFields, veeErrors, 'Altura')" v-bind="money2"></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Largura (em cm)</span>
          <money class="w-full vs-inputx vs-input--input large" name="Largura" id="Largura"
            v-model="formCadastro.largura" v-validate="{ required: !formCadastro.valorIntangivel }"
            :state="utilsList.validateState(veeFields, veeErrors, 'Largura')"
            :danger="!utilsList.validateState(veeFields, veeErrors, 'Largura')" v-bind="money2"></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Comprimento (em cm)</span>
          <money class="w-full vs-inputx vs-input--input large" name="Comprimento" id="Comprimento"
            v-model="formCadastro.comprimento" v-validate="{ required: !formCadastro.valorIntangivel }" :state="utilsList.validateState(veeFields, veeErrors, 'Comprimento')
              " :danger="!utilsList.validateState(veeFields, veeErrors, 'Comprimento')
                " v-bind="money2"></money>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Peso em Gramas</span>
          <vs-input class="w-full" name="Peso em Gramas" id="Peso em Gramas" type="number"
            v-model="formCadastro.pesoGramas" v-validate="{ required: !formCadastro.valorIntangivel }" :state="utilsList.validateState(veeFields, veeErrors, 'Peso em Gramas')
              " :danger="!utilsList.validateState(veeFields, veeErrors, 'Peso em Gramas')
                " val-icon-danger="clear" danger-text="Preencha este Campo" />
        </div>
      </div>

      <!-- Campos sku, ncm, cst e cfop -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>sku</span>
          <vs-input class="w-full" name="sku" id="sku" v-model="formCadastro.sku" v-validate="{ required: true }"
            :state="utilsList.validateState(veeFields, veeErrors, 'sku')"
            :danger="!utilsList.validateState(veeFields, veeErrors, 'sku')" val-icon-danger="clear"
            danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>ncm</span>
          <vs-input class="w-full" name="ncm" id="ncm" v-model="formCadastro.ncm" v-validate="{ required: true }"
            :state="utilsList.validateState(veeFields, veeErrors, 'ncm')"
            :danger="!utilsList.validateState(veeFields, veeErrors, 'ncm')" val-icon-danger="clear"
            danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>cst</span>
          <vs-input class="w-full" name="cst" id="cst" v-model="formCadastro.cst" v-validate="{ required: true }"
            :state="utilsList.validateState(veeFields, veeErrors, 'cst')"
            :danger="!utilsList.validateState(veeFields, veeErrors, 'cst')" val-icon-danger="clear"
            danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>cfop</span>
          <vs-input class="w-full" name="cfop" id="cfop" v-model="formCadastro.cfop" v-validate="{ required: true }"
            :state="utilsList.validateState(veeFields, veeErrors, 'cfop')"
            :danger="!utilsList.validateState(veeFields, veeErrors, 'cfop')" val-icon-danger="clear"
            danger-text="Preencha este Campo" />
        </div>
      </div>

      <!-- Campo Estoque: exibido somente se não houver variações -->
      <div class="vx-row mb-6" v-if="formCadastro.variacoes.length === 0">
        <div class="vx-col w-full">
          <span>Estoque</span>
          <vs-input class="w-full" name="estoque" id="estoque" type="number" v-model="formCadastro.estoque"
            v-validate="{ required: true }" :state="utilsList.validateState(veeFields, veeErrors, 'estoque')"
            :danger="!utilsList.validateState(veeFields, veeErrors, 'estoque')" val-icon-danger="clear"
            danger-text="Preencha este Campo" />
        </div>
      </div>

      <!-- Seção de Variações -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Variações</span>
          <vs-button color="warning" type="border" class="mr-3 mb-2 w-full" @click.stop.prevent="abrirModalVariacao">
            Adicionar Variação
          </vs-button>
          <br />
          <vs-list-item v-for="(item, index) in formCadastro.variacoes" :key="index" :title="item.variacao"
            :subtitle="item.valor + ' / Quantidade: ' + item.quantidade + ' / SKU: ' + item.sku">
            <template #avatar>
              <div class="flex">
                <vs-button @click.stop.prevent="editarVariacao(item, index)" class="mr-2" color="primary" type="border"
                  icon="edit">
                </vs-button>
                <vs-button @click.stop.prevent="deletaVariacao(item)" class="mr-2" color="danger" type="border"
                  icon="clear">
                </vs-button>
              </div>
            </template>
          </vs-list-item>
        </div>
      </div>

      <!-- Popup (Modal) para Adicionar/Editar Variação -->
      <vs-popup class="holamundo" title="Informações dados da Variação" @cancel="clearFormVariacao"
        :active.sync="activePromptVariacao">
        <div>
          <div class="my-2">
            <label>Variação</label>
            <v-select class="w-full large" :options="variacoes" name="variacoes" id="variacoes"
              v-model="formVariacao.variacao" />
          </div>
          <div class="my-2">
            <label>Valor</label>
            <vs-input class="w-full" name="variacaoValor" id="variacaoValor" v-model="formVariacao.valor"
              val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
          <div class="my-2">
            <label>SKU</label>
            <vs-input class="w-full" name="sku" id="sku" v-model="formVariacao.sku" val-icon-danger="clear"
              danger-text="Preencha este Campo" />
          </div>
          <div class="my-2">
            <label>Quantidade</label>
            <vs-input class="w-full" name="variacaoQuantidade" id="variacaoQuantidade" type="number"
              v-model="formVariacao.quantidade" val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
          <vs-button color="success" class="w-full mt-2" @click="salvarVariacao">
            Salvar
          </vs-button>
        </div>
      </vs-popup>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Status do Produto</span>
          <vs-switch color="success" v-model="statusBoolean" style="width: 60px">
            <span slot="1">Sim</span>
            <span slot="0">Não</span>
          </vs-switch>
        </div>
      </div>

      <!-- Alert de Erros de Validação -->
      <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true" class="my-3"
        style="height: auto !important">
        <ul>
          <li v-for="error in $validator.errors.all()" :key="error.id" class="mb-2">
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <!-- Botões de Ação -->
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">
            Cancelar
          </vs-button>
          <BotaoSubmit variant="success" :edit="dados.idProduto ? true : false" :aguarde="aguardeCadastro" />
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>

<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { Money } from "v-money";

export default {
  props: {
    sideBar: { type: Boolean },
    dados: { type: Object },
    contadorRender: { type: Number },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    contadorRender() {
      this.preencheForm();
    },
    "formCadastro.isBling"(value) {
      if (value === true && !this.formCadastro.idBling) {
        console.log("abre modal bling", this.formCadastro.idBling);
        this.integraBling();
      }
    },
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: true,
      },
      money2: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: true,
      },
      utilsList,
      aguardeCadastro: false,
      situacoes: ["Ativo", "Inativo"],
      languages: lang,
      funcoesValicao: null,
      files: new FormData(),
      imagem: null,
      temaCor: {},
      editorOption: {},
      // Formulário da variação usado na modal
      formVariacao: {
        variacao: null,
        valor: null,
        quantidade: null,
      },
      formVoucher: { codigo: null }, // novo
      activePromptVoucher: false,    // novo
      // Lista de variações disponíveis
      variacoes: ["Tamanho", "Cor", "Marca", "Modelo"],
      activePromptVariacao: false,
      // Flags para controle do modo edição de variação
      editingVariacao: false,
      editingIndex: null,
      // Formulário principal do produto
      formCadastro: {
        idProduto: null,
        idEmpresa: null,
        nomeProduto: null,
        corHexaDefault: null,
        status: 1,
        imagem: null,
        descricao: null,
        valorEstimado: 0,
        valorIntangivel: null,
        coin: null,
        syncJobUpdate: null,
        isVoucher: null,
        vouchers: [],
        valorCompra: 0,
        valorVenda: 0,
        altura: 0,
        largura: 0,
        comprimento: 0,
        pesoGramas: 0,
        sku: null,
        ncm: null,
        cst: null,
        cfop: null,
        estoque: null,
        jsonFacilitadorImpostos: null,
        variacoes: [],
        idBling: null,
        isBling: false,
      },
    };
  },
  methods: {
    abrirModalVoucher() {
      this.clearFormVoucher();
      this.activePromptVoucher = true;
    },
    clearFormVoucher() {
      this.formVoucher = { codigo: null };
    },
    salvarVoucher() {
      if (this.formVoucher.codigo) {
        const jaExiste = this.formCadastro.vouchers.find(
          x => x.voucher === this.formVoucher.codigo
        );

        if (jaExiste) {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Voucher já adicionado",
            color: "danger",
          });
          return;
        }

        // Agora salva como objeto
        this.formCadastro.vouchers.push({
          voucher: this.formVoucher.codigo,
          requested: 0
        });

        this.clearFormVoucher();
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Preencha o código do voucher",
          color: "warning",
        });
      }
    },
    deletaVoucher(index) {
      const voucher = this.formCadastro.vouchers[index];
      if (voucher.requested === 1) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Este voucher já foi usado e não pode ser excluído.",
          color: "warning",
        });
        return;
      }
      this.formCadastro.vouchers.splice(index, 1);
    },
    clearFormVariacao() {
      this.formVariacao = {
        variacao: null,
        valor: null,
        quantidade: null,
      };
      this.editingVariacao = false;
      this.editingIndex = null;
    },
    abrirModalVariacao() {
      this.clearFormVariacao();
      this.activePromptVariacao = true;
    },
    editarVariacao(item, index) {
      this.formVariacao = { ...item };
      this.editingVariacao = true;
      this.editingIndex = index;
      this.activePromptVariacao = true;
    },
    salvarVariacao() {
      if (
        this.formVariacao.variacao &&
        this.formVariacao.valor
      ) {
        if (this.editingVariacao) {
          this.$set(this.formCadastro.variacoes, this.editingIndex, {
            ...this.formVariacao,
          });
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Variação atualizada com sucesso",
            color: "success",
          });
        } else {
          const jaExiste = this.formCadastro.variacoes.find(
            (x) =>
              x.variacao === this.formVariacao.variacao &&
              x.valor === this.formVariacao.valor
          );
          if (jaExiste) {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Variação já adicionada",
              color: "danger",
            });
            return;
          } else {
            this.formCadastro.variacoes.push({ ...this.formVariacao });
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Variação adicionada com sucesso",
              color: "success",
            });
          }
        }
        this.clearFormVariacao();
        this.editingVariacao = false;
        this.editingIndex = null;
        this.activePromptVariacao = false;
        this.ordenaVariacoes();
        this.recalculaEstoque();
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Preencha todos o campos (variação e valor).",
          color: "warning",
        });
      }
    },
    deletaVariacao(item) {
      const idx = this.formCadastro.variacoes.findIndex(
        (v) =>
          v.variacao === item.variacao &&
          v.valor === item.valor &&
          v.quantidade === item.quantidade
      );
      if (idx !== -1) {
        this.formCadastro.variacoes.splice(idx, 1);
        this.ordenaVariacoes();
        this.recalculaEstoque();
      }
    },
    ordenaVariacoes() {
      this.formCadastro.variacoes.sort((a, b) => {
        if (a.variacao < b.variacao) return -1;
        if (a.variacao > b.variacao) return 1;
        return 0;
      });
    },
    recalculaEstoque() {
      let total = 0;
      this.formCadastro.variacoes.forEach((item) => {
        total += Number(item.quantidade) || 0;
      });
      this.formCadastro.estoque = total;
    },
    onEditorChange({ quill, html, text }) {
      this.formCadastro.descricao = html;
    },
    changeThemeColor(event) {
      const { value } = event.target;
      this.formCadastro.corHexaDefault = value;
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
    },
    selecionaImagem(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.files.set("file", files[0], files[0].name);
      this.imagem = files[0].name;
      this.$vs.loading();
      service
        .upload("Upload", "Produto", this.files)
        .then((response) => {
          this.formCadastro.imagem = response;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    preencheForm() {
      if (this.dados && this.dados.idProduto) {
        let variacoes = this.dados.variacoes;
        if (typeof variacoes === "string") {
          try {
            variacoes = JSON.parse(variacoes);
          } catch (e) {
            variacoes = [];
          }
        }
        // Garante que cada variação possua o campo "quantidade"
        this.formCadastro.variacoes = variacoes.map((item) => ({
          ...item,
          quantidade: item.hasOwnProperty("quantidade") ? item.quantidade : "",
        }));

        let vouchers = this.dados.Vouchers;
        if (vouchers) {
          try {
            if (typeof vouchers === "string" && vouchers.startsWith("\"")) {
              vouchers = JSON.parse(JSON.parse(vouchers));
            } else if (typeof vouchers === "string") {
              vouchers = JSON.parse(vouchers);
            }
          } catch (e) {
            vouchers = [];
          }
        } else {
          vouchers = [];
        }
        this.formCadastro.vouchers = vouchers;


        Object.assign(this.formCadastro, {
          idProduto: this.dados.idProduto,
          nomeProduto: this.dados.nomeProduto,
          corHexaDefault: this.dados.corHexaDefault,
          imagem: this.dados.imagem,
          descricao: this.dados.descricao,
          valorEstimado: parseFloat(this.dados.valorEstimado),
          valorIntangivel: this.dados.valorIntangivel,
          coin: this.dados.coin,
          syncJobUpdate: this.dados.syncJobUpdate,
          isVoucher: this.dados.isVoucher === 1 || this.dados.isVoucher === true,
          valorCompra: parseFloat(this.dados.valorCompra),
          valorVenda: 0,
          altura: this.dados.altura,
          largura: this.dados.largura,
          comprimento: this.dados.comprimento,
          pesoGramas: this.dados.pesoGramas,
          sku: this.dados.sku,
          ncm: this.dados.ncm,
          cst: this.dados.cst,
          cfop: this.dados.cfop,
          estoque: this.dados.estoque,
          jsonFacilitadorImpostos: this.dados.jsonFacilitadorImpostos,
          idBling: this.dados.idBling,
          isBling: this.dados.idBling ? true : false,
          status:
            this.dados.status !== undefined && this.dados.status !== null
              ? this.dados.status
              : 1,
        });
        this.ordenaVariacoes();
        this.imagem = this.dados.imagem;
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      let action = "Atualizar/" + this.formCadastro.idProduto;
      let metodo = "put";
      if (!this.formCadastro.idProduto) {
        action = "Adicionar";
        metodo = "post";
      }

      const objSend = { ...this.formCadastro };

      // vouchers sempre como string
      if (this.formCadastro.vouchers && Array.isArray(this.formCadastro.vouchers)) {
        objSend.Vouchers = JSON.stringify(this.formCadastro.vouchers);
      }

      // garantir coerência de booleanos → números (porque o banco usa BIT / int)
      objSend.isVoucher = this.formCadastro.isVoucher ? 1 : 0;
      objSend.valorIntangivel = this.formCadastro.valorIntangivel ? 1 : 0;
      objSend.coin = this.formCadastro.coin ? 1 : 0;
      objSend.syncJobUpdate = this.formCadastro.syncJobUpdate ? 1 : 0;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Produtos", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: "Operação realizada com sucesso",
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null) {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          }
        });
      });
    },
    resetForm() {
      this.formCadastro = {
        idProduto: null,
        idEmpresa: null,
        nomeProduto: null,
        corHexaDefault: null,
        status: 1,
        imagem: null,
        descricao: null,
        valorEstimado: 0,
        valorIntangivel: null,
        coin: null,
        syncJobUpdate: null,
        isVoucher: null,
        vouchers: [],
        valorCompra: 0,
        valorVenda: 0,
        altura: null,
        largura: null,
        comprimento: null,
        pesoGramas: null,
        sku: null,
        ncm: null,
        cst: null,
        cfop: null,
        estoque: null,
        jsonFacilitadorImpostos: null,
        variacoes: [],
        idBling: null,
        isBling: false,
      };
      this.imagem = null;
    },
    onReset() {
      this.$emit("cancel");
      this.resetForm();
    },
    getParamsBling() {
      const url = window.location.href;
      const urlObj = new URL(url);
      this.bling.code = urlObj.searchParams.get("code");
      this.bling.state = urlObj.searchParams.get("state");
    },
  },
  computed: {
    statusBoolean: {
      get() {
        return this.formCadastro.status === 1;
      },
      set(value) {
        this.formCadastro.status = value ? 1 : 0;
      },
    },
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Money,
    quillEditor,
  },
};
</script>

<style scoped>
#fileInput {
  display: none;
}

.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}

.span-sub {
  color: rgb(60, 60, 60);
  font-size: 11px;
  margin-bottom: 5px;
}
</style>
